import React, { useState } from "react"
import { QuizButton } from "./QuizButton"

interface QuestionData {
  correctAnswer: number // 0-indexed
  top: number
  left: number
  verticalSpacing: number[] //specify single number if they are all the same
  image: any
}

const Answers: QuestionData[][] = [
  [
    {
      correctAnswer: 1,
      top: 166,
      left: 168,
      verticalSpacing: [34],
      image: process.env.PUBLIC_URL + "/images/quiz_1_1.png",
    },
    {
      correctAnswer: 1,
      top: 154,
      left: 80,
      verticalSpacing: [0, 34, 84, 118, 174],
      image: process.env.PUBLIC_URL + "/images/quiz_1_2.png",
    },
  ],
  [
    {
      correctAnswer: 3,
      top: 167,
      left: 178,
      verticalSpacing: [34],
      image: process.env.PUBLIC_URL + "/images/quiz_2_1.png",
    },
    {
      correctAnswer: 4,
      top: 172,
      left: 178,
      verticalSpacing: [30],
      image: process.env.PUBLIC_URL + "/images/quiz_2_2.png",
    },
    {
      correctAnswer: 3,
      top: 183,
      left: 144,
      verticalSpacing: [32],
      image: process.env.PUBLIC_URL + "/images/quiz_2_3.png",
    },
    {
      correctAnswer: 4,
      top: 196,
      left: 114,
      verticalSpacing: [30],
      image: process.env.PUBLIC_URL + "/images/quiz_2_4.png",
    },
    {
      correctAnswer: 2,
      top: 213,
      left: 125,
      verticalSpacing: [29],
      image: process.env.PUBLIC_URL + "/images/quiz_2_5.png",
    },
    {
      correctAnswer: 0,
      top: 205,
      left: 159,
      verticalSpacing: [30],
      image: process.env.PUBLIC_URL + "/images/quiz_2_6.png",
    },
  ],
  [],
]

interface Props {
  quizIndex: number
  onQuizComplete: VoidFunction
}

export const Quiz: React.FC<Props> = (props) => {
  const { quizIndex, onQuizComplete } = props
  const currentQuiz = Answers[quizIndex]
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
  const currrentQuestion = currentQuiz[currentQuestionIndex]

  const handleCorrectButtonClicked = () => {
    console.log("correct!")
    if (currentQuestionIndex < currentQuiz.length - 1) {
      setCurrentQuestionIndex((oldvalue) => oldvalue + 1)
    } else {
      onQuizComplete()
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <img
        style={{ width: "100%", height: "100%" }}
        src={currrentQuestion.image}
        alt=""
      />
      <ButtonList
        currentQuestion={currrentQuestion}
        onCorrectAnswerClicked={handleCorrectButtonClicked}
      />
    </div>
  )
}

interface ButtonListProps {
  currentQuestion: QuestionData
  onCorrectAnswerClicked: VoidFunction
}

const ButtonList: React.FC<ButtonListProps> = (props) => {
  const { currentQuestion, onCorrectAnswerClicked } = props
  const initialTop = currentQuestion.top
  const correctAnswer = currentQuestion.correctAnswer
  let verticalSpacing = currentQuestion.verticalSpacing
  if (verticalSpacing.length === 1) {
    verticalSpacing = [
      0,
      currentQuestion.verticalSpacing[0],
      currentQuestion.verticalSpacing[0] * 2,
      currentQuestion.verticalSpacing[0] * 3,
      currentQuestion.verticalSpacing[0] * 4,
    ]
  }

  const handleButtonClick = (rightAnswer?: boolean) => {
    if (rightAnswer) {
      onCorrectAnswerClicked()
    }
  }
  return (
    <div>
      {verticalSpacing.map((_value, index) => (
        <QuizButton
          key={`QuizButton-${index}`}
          top={initialTop + verticalSpacing[index]}
          left={currentQuestion.left}
          onClick={handleButtonClick}
          rightAnswer={correctAnswer === index}
        />
      ))}
    </div>
  )
}
